import React from 'react';
import { withTabItems } from '../common/RoutableTabContainer';
import PortfolioOrderList from './PortfolioOrderList';
import StockOrderList from './StockOrderList';
import BrokerOrderList from './BrokerOrderList';
import FxOrderList from './FxOrderList';
import ExchangeSession from './ExchangeSession';
import BulkOrderList from './BulkOrderList';
import OrderApprovalList from './OrderApprovalList';
import OrderProposalList from './OrderProposalList';
import PortfolioOrderRequestList from './PortfolioOrderRequestList';
import OffMarketTradeList from './OffMarketTradeList';
import withSuspense from '../common/table/Suspention';
import CSIcon from '../activityCS/CSIcon';


const stockOrderItems = (process.env.DEPLOYMENT_CODE === 'UK') ? [
  {
    label: 'Stock Order',
    url: 'stock-orders',
    comp: StockOrderList,
    tooltip: 'Account level stock orders placed through IB',
    propCopyFn: props => ({ instrumentTypeIn: ['STK', 'WAR'] }),
  },
  {
    label: 'Fund Order',
    url: 'fund-orders',
    comp: StockOrderList,
    tooltip: 'Account level fund orders placed through Clearstream',
    propCopyFn: props => ({ instrumentTypeIn: ['FUN'] }),
  },
  {
    label: 'Order File',
    titleLabel: 'CS Order File',
    url: 'cs-order-file',
    tooltip: 'Order file that will be uploaded to Clearstream Vestima interface',
    icon: CSIcon,
    comp: withSuspense(React.lazy(() => import('./uk/CSOrderFileList'))),
  },
] : [
  {
    label: 'Stock Order',
    url: 'stock-orders',
    comp: StockOrderList,
  },
];

export default withTabItems([
  ...stockOrderItems,
  {
    label: 'Vue Order',
    url: 'vue-orders',
    comp: PortfolioOrderList,
    tooltip: 'Collection of stock orders placed against specific Vue/Portfolio',
  },
  {
    label: 'Fx Order',
    url: 'fx-orders',
    comp: FxOrderList,
  },
  {
    label: 'Broker Order',
    url: 'broker-orders',
    comp: BrokerOrderList,
  },
  {
    label: 'Bulk Order',
    url: 'bulk-orders',
    comp: BulkOrderList,
  },
  {
    label: 'Proposals',
    url: 'proposals',
    comp: OrderProposalList,
  },
  {
    label: 'Approvals',
    url: 'approvals',
    comp: OrderApprovalList,
  },
  {
    label: 'Off Market',
    url: 'off-market-trades',
    comp: OffMarketTradeList,
  },
  {
    label: 'Exchange Session',
    url: 'exchange-session',
    comp: ExchangeSession,
  },
  {
    label: 'Order Request',
    url: 'order-requests',
    comp: PortfolioOrderRequestList,
    permission: ['TRD'],
  },
], () => 'Orders \u2022 ');
